export const initialState = ({
  id,
  title = 'NewTheme',
  createdBy = 'user',
  palette: {
    primary: primaryColor = '#f4354c',
    title: titleColor = '#000000',
    subtitle: subtitleColor = '#6d6d6d',
    background: backgroundColor = '#ffffff',
    cardBackground: cardBackgroundColor = '#f2f2f2',
    saparator: saparatorColor = '#dee0e2',
    coverBackaground: coverBackagroundColor = '#0283ff',
    coverText: coverTextColor = '#ffffff',
    description: descriptionColor = '#7f7f7f',
    coverHasGradiant = false,
  } = {},
} = {}) => ({
  id,
  title,
  primaryColor,
  titleColor,
  subtitleColor,
  backgroundColor,
  cardBackgroundColor,
  saparatorColor,
  coverBackagroundColor,
  coverTextColor,
  descriptionColor,
  coverHasGradiant,
  isCreateByUser: createdBy === 'user',
  isEditMode: !!id,
});

export const types = {
  SET_TITLE: 'SET_TITLE',
  SET_PRIMARY_COLOR: 'SET_PRIMARY_COLOR',
  SET_TITLE_COLOR: 'SET_TITLE_COLOR',
  SET_SUBTITLE_COLOR: 'SET_SUBTITLE_COLOR',
  SET_BACKGROUND_COLOR: 'SET_BACKGROUND_COLOR',
  SET_CARD_BACKGROUND_COLOR: 'SET_CARD_BACKGROUND_COLOR',
  SET_SAPARATOR_COLOR: 'SET_SAPARATOR_COLOR',
  SET_COVER_BACKGROUND_COLOR: 'SET_COVER_BACKGROUND_COLOR',
  SET_COVER_TEXT_COLOR: 'SET_COVER_TEXT_COLOR',
  SET_DESCRIPTION_COLOR: 'SET_DESCRIPTION_COLOR',
  SET_COVER_HAS_GRADIANT: 'SET_COVER_HAS_GRADIANT',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_TITLE:
      return { ...state, title: payload };
    case types.SET_PRIMARY_COLOR:
      return { ...state, primaryColor: payload };
    case types.SET_SAPARATOR_COLOR:
      return { ...state, saparatorColor: payload };
    case types.SET_TITLE_COLOR:
      return { ...state, titleColor: payload };
    case types.SET_SUBTITLE_COLOR:
      return { ...state, subtitleColor: payload };
    case types.SET_BACKGROUND_COLOR:
      return { ...state, backgroundColor: payload };
    case types.SET_CARD_BACKGROUND_COLOR:
      return { ...state, cardBackgroundColor: payload };
    case types.SET_COVER_BACKGROUND_COLOR:
      return { ...state, coverBackagroundColor: payload };
    case types.SET_COVER_TEXT_COLOR:
      return { ...state, coverTextColor: payload };
    case types.SET_DESCRIPTION_COLOR:
      return { ...state, descriptionColor: payload };
    case types.SET_COVER_HAS_GRADIANT:
      return { ...state, coverHasGradiant: payload };
    default:
      throw new Error();
  }
};
